
import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import './GameLayout.css';

const GameLayout = ({ children, userData, onLogout }) => {


  return (
    <div className="game-layout">

      <div className="game-area">
        {children}
      </div>
      <div className="sidebar-area">
        <Sidebar userData={userData} onLogout={onLogout} />
      </div>
    </div>
  );
};

export default GameLayout;
